import React, { useEffect, useState } from "react";
import { Form, Container, Card, ButtonGroup, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { api } from "./pureFunctions";
import { header } from "./globalVariables";

const OPTIONS = {
   notifications: {
      key: "notifications",
      label: "Benachrichtigungen",
      options: [{ key: "akquiseRueckfrage", name: "Akquise-Rückrufdatum" }],
   },
};

export default function Nutzereinstellungen() {
   const [settings, setSettings] = useState({});

   async function getUserData() {
      try {
         const data = await api.get(`api/ip/userdata`, {
            params: {
               reqData: ["settings"],
            },
            ...header,
         });
         console.log(data);
         setSettings(data?.data?.settings ?? {});
      } catch (err) {
         console.log(err);
      }
   }

   async function updateUserData(data) {
      console.log(data);

      const savedResponse = await api.post("/api/ip/userData", { settings: data }, header).then((data) => {
         console.log("saved Data");
         console.log(data);
      });
   }

   useEffect(() => {
      getUserData();
   }, []);

   function changeSettings(key, name, value) {
      let newSettings = structuredClone(settings);
      //   newSettings[key][name] = value;
      (newSettings[key] ??= {})[name] = value;
      updateUserData(newSettings);
      setSettings(newSettings);
   }

   return (
      <Container className="py-4" style={{}}>
         <h2 className="mb-4">Nutzereinstellungen</h2>
         <Form>
            {Object.values(OPTIONS).map((katItem) => {
               return (
                  <Card className="mb-4">
                     <Card.Body>
                        <Card.Title as="h5" className="mb-3">
                           {katItem.label}
                        </Card.Title>
                        <Form.Group className="mb-3">
                           <ButtonGroup>
                              {katItem.options.map((optItem) => {
                                 return (
                                    <Button
                                       variant={
                                          settings?.[katItem.key]?.[optItem.key] ? "primary" : "outline-secondary"
                                       }
                                       onClick={() => {
                                          changeSettings(
                                             katItem.key,
                                             optItem.key,
                                             !settings?.[katItem.key]?.[optItem.key],
                                          );
                                       }}
                                    >
                                       {optItem.name}
                                    </Button>
                                 );
                              })}
                           </ButtonGroup>
                        </Form.Group>
                     </Card.Body>
                  </Card>
               );
            })}

            {/*  <Card className="mb-4">
               <Card.Body>
                  <Card.Title as="h5" className="mb-3">
                     Theme
                  </Card.Title>

                  <Form.Group className="mb-3" controlId="darkModeToggle">
                     <Form.Check
                        type="switch"
                        label="Dunkelmodus aktivieren"
                        checked={theme === "dark"}
                        onChange={(e) => setTheme(e.target.checked ? "dark" : "light")}
                     />
                  </Form.Group>

                  <Form.Group controlId="themeAuswahl">
                     <Form.Label>Theme-Modus</Form.Label>
                     <Form.Select value={theme} onChange={(e) => setTheme(e.target.value)}>
                        <option value="system">Systemeinstellung</option>
                        <option value="light">Hell</option>
                        <option value="dark">Dunkel</option>
                     </Form.Select>
                  </Form.Group>
               </Card.Body>
            </Card> */}
         </Form>
      </Container>
   );
}
